/**
 * Returns a number limited to the given range.
 *
 * @param {number} val The number to be limited to a range
 * @param {number} min The lower boundary of the limit range
 * @param {number} max The upper boundary of the limit range
 * @returns {number} A number in the range [min, max]
 */
export default function clamp(val, min, max) {
    return Math.min(Math.max(min, val), max);
}



// WEBPACK FOOTER //
// webpack://WaveSurfer/src/util/clamp.js